import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InformationSection = styled.div`
  > h3 {
    margin-bottom: 16px;
  }
`;

export const WarrantyDisclaimer = styled.div`
  margin-top: 16px;
  font-style: italic;
`;
